var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "guest-form-container form-container" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "contact-form" }, [
      _c(
        "div",
        {
          staticClass: "contact-field",
          class: _vm.validateClass(_vm.hasValidName(_vm.guestNameModel))
        },
        [
          _c("BaseIcon", {
            staticClass: "input-field-icon",
            attrs: { icon: "userEdit", size: "1x" }
          }),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.guestNameModel,
                expression: "guestNameModel"
              }
            ],
            staticClass: "input text-input has-icon",
            attrs: { type: "text", placeholder: "Name" },
            domProps: { value: _vm.guestNameModel },
            on: {
              blur: function($event) {
                return _vm.updateName()
              },
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.guestNameModel = $event.target.value
              }
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "contact-field", class: _vm.updatePhoneClass() },
        [
          _c("BaseIcon", {
            staticClass: "input-field-icon",
            attrs: { icon: "phone", size: "1x" }
          }),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.phone,
                expression: "phone"
              }
            ],
            staticClass: "input text-input has-icon",
            attrs: { type: "tel", placeholder: "Phone (607) 123 4567" },
            domProps: { value: _vm.phone },
            on: {
              blur: function($event) {
                return _vm.updatePhone()
              },
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.phone = $event.target.value
              }
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "contact-form" },
        [
          _c("BaseButton", {
            attrs: {
              classNames: ["button--modifier", "input-field-button"],
              title: "Continue",
              type: "scaleable-fixed-square",
              disabled: !_vm.validateAccount()
            },
            on: { click: _vm.handleClickContinue }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "small-link",
          on: {
            click: function($event) {
              $event.preventDefault()
              return _vm._navigateToSignIn($event)
            }
          }
        },
        [_vm._v("or sign in with an account")]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "center-message" }, [
      _c("p", [_vm._v("Continue order as a guest?")]),
      _vm._v(" "),
      _c("p", [_vm._v("Please enter your details:")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d5e41f4c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d5e41f4c","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/account/GuestForm.vue
// module id = null
// module chunks = 